



























import {Component, Vue} from "vue-property-decorator";
    import Calls from "@/components/logs/Calls.vue";
    import Recordings from "@/components/logs/Recordings.vue";
    import Notifications from "@/components/logs/Notifications.vue";
    import Navbar from "@/components/elements/molecules/Navbar.vue";
import {Pages} from "@/class/pages";

    @Component({
        components:{
          Navbar,
            Calls,
            Recordings,
            Notifications
        }
    })
    export default class Logs extends Vue {
      private tab = 'calls';

      private activePage = 0;

      private pages: Pages = {
        current: 0,
        max: 0,
        size: 0,
        total: 0,
        url: "",
      };

      showCalls() {
        this.tab = 'calls';
      }

      showNotifications() {
        this.tab = 'notifications';
      }

      showRecordings() {
        this.tab = 'recordings';
      }

      passPages(pages: Pages) {
        this.pages = pages;
      }

      choosePage(page: number) {
        this.activePage = page;
      }
    }
